export const DEFAULT_COUNTRY_CODE = 'bf';


// WEBPACK FOOTER //
// ./src/constants/countries.js